/* ============================================================
   HimalayaEcho · PDP "Make It a Set"（2026-06-17 PDP 改版）
   本品 + 1 搭配件（custom.pair_handle 优先 → 相关推荐[同石色→同元素→第一件] → 集合随机兜底）。
   Add both = 加 2 件 → Buy 2 save 10% 自动折扣生效。无搭配件则整块隐藏。
   ============================================================ */
(function () {
  'use strict';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  ROOT = ROOT.replace(/\/$/, '');

  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function fixImg(u) { return (u && u.indexOf('//') === 0) ? 'https:' + u : u; }

  function setup(box) {
    if (box.dataset.heMiasDone === '1') return;
    box.dataset.heMiasDone = '1';

    var selfId = box.getAttribute('data-product-id');
    var selfVariant = parseInt(box.getAttribute('data-variant-id'), 10);
    var selfPrice = parseInt(box.getAttribute('data-price'), 10) || 0;
    var pairHandle = (box.getAttribute('data-pair-handle') || '').trim();

    var color = (box.getAttribute('data-color') || '').trim();
    var element = (box.getAttribute('data-element') || '').trim();

    function fromList(arr) {
      var list = (arr || []).filter(function (p) {
        return String(p.id) !== String(selfId) && p.available !== false;
      });
      // 配色优先级：同石色(birthstone) → 同元素(element/palette) → 第一件
      // 多一档 element 兜手，把"取第一件(任意)"的占比压到更低，配对更成套。
      if (color) {
        var sameStone = list.filter(function (p) { return (p.tags || []).indexOf(color) !== -1; });
        if (sameStone.length) return sameStone[0];
      }
      if (element) {
        var sameEl = list.filter(function (p) { return (p.tags || []).indexOf(element) !== -1; });
        if (sameEl.length) return sameEl[0];
      }
      return list[0] || null;
    }

    function recommend() {
      return fetch(ROOT + '/recommendations/products.json?product_id=' + selfId + '&limit=10&intent=related')
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { return fromList(d.products); })
        .catch(function () { return null; }); // 接口抖动(503/限流)时不报错,交给兜底
    }

    // 兜底：从策展集合取一件（≠本品、有货、随机以增加多样性），再用 .js 拉成统一格式，保证每个 PDP 都有 bundle
    function fromCollection(handle) {
      return fetch(ROOT + '/collections/' + handle + '/products.json?limit=30')
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) {
          var cands = (d.products || []).filter(function (p) {
            return String(p.id) !== String(selfId) && (p.variants || []).some(function (v) { return v.available; });
          });
          if (!cands.length) return null;
          var cand = cands[Math.floor(Math.random() * cands.length)];
          return fetch(ROOT + '/products/' + cand.handle + '.js').then(function (r) { return r.ok ? r.json() : null; });
        }).catch(function () { return null; });
    }

    function fallback() {
      return fromCollection('best-sellers').then(function (p) { return p || fromCollection('customer-favorites'); });
    }

    // pair_handle（校验有货）→ 推荐 → 策展兜底；任一命中即停，保证总有搭配件
    var pick = (pairHandle
      ? fetch(ROOT + '/products/' + pairHandle + '.js').then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) { return (p && p.available !== false) ? p : recommend(); })
          .catch(function () { return recommend(); })
      : recommend()
    ).then(function (p) { return p || fallback(); });

    pick.then(function (p) {
      if (!p) { box.hidden = true; return; }
      var v = (p.variants || []).filter(function (x) { return x.available !== false; })[0] || (p.variants && p.variants[0]);
      if (!v) { box.hidden = true; return; }
      var compPrice = (typeof v.price === 'number') ? v.price : (typeof p.price === 'number' ? p.price : 0);
      var img = fixImg(p.featured_image || (p.images && p.images[0]) || (p.media && p.media[0] && p.media[0].preview_image && p.media[0].preview_image.src) || '');

      var imgEl = box.querySelector('[data-he-mias-img]');
      /* 有查询串拼 &、无查询串拼 ?(原三元反了:全尺寸原图被当 80px 缩略图加载) */
      if (imgEl && img) { imgEl.src = img + (img.indexOf('?') === -1 ? '?width=160' : '&width=160'); imgEl.alt = p.title || ''; }
      var linkEl = box.querySelector('[data-he-mias-link]');
      if (linkEl) { linkEl.href = p.url || (ROOT + '/products/' + p.handle); }
      var nameEl = box.querySelector('[data-he-mias-name]');
      if (nameEl) nameEl.textContent = p.title || '';

      var total = selfPrice + compPrice;
      /* 折扣率单一真源:主题设置 settings.bundle_pct_2 → Liquid 写进 data-set-pct;别再写死倍率 */
      var setPct = parseFloat(box.getAttribute('data-set-pct'));
      if (isNaN(setPct) || setPct < 0 || setPct > 90) setPct = 12;
      /* 按"每件打折后取整再求和"算,和 Pumper(购物车)完全一致,避免整单取整差 1 分 */
      var factor = 1 - setPct / 100;
      var setPrice = Math.round(selfPrice * factor) + Math.round(compPrice * factor);
      var totalEl = box.querySelector('[data-he-mias-total]');
      var wasEl = box.querySelector('[data-he-mias-was]');
      if (totalEl) totalEl.textContent = money(setPrice);
      if (wasEl) wasEl.textContent = money(total);

      var btn = box.querySelector('[data-he-mias-add]');
      if (btn) {
        btn.disabled = false;
        btn.setAttribute('data-vids', selfVariant + ',' + v.id);
      }
      box.hidden = false;
    }).catch(function () { box.hidden = true; });
  }

  function addBoth(btn) {
    var vids = (btn.getAttribute('data-vids') || '').split(',').map(function (n) { return parseInt(n, 10); }).filter(Boolean);
    if (vids.length < 2) return;
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch(ROOT + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: vids.map(function (id) { return { id: id, quantity: 1 }; }),
        sections: 'cart-drawer,cart-icon-bubble'
      })
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (data && data.sections) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && data.sections['cart-drawer']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = data.sections['cart-drawer'];
          var fresh = tmp.querySelector('cart-drawer');
          if (fresh) drawer.innerHTML = fresh.innerHTML;
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && data.sections['cart-icon-bubble']) {
          var t2 = document.createElement('div'); t2.innerHTML = data.sections['cart-icon-bubble'];
          var fb = t2.querySelector('#cart-icon-bubble') || t2.firstElementChild;
          if (fb) bubble.innerHTML = fb.innerHTML;
        }
        btn.textContent = 'Added';
        if (drawer && typeof drawer.open === 'function') {
          drawer.classList.remove('is-empty');
          drawer.open(btn);
        } else {
          window.location.href = ROOT + '/cart';
        }
        setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 1500);
      } else if (data && (data.status >= 400 || data.errors || data.description)) {
        /* /cart/add.js 错误载荷(422/429):别当成功跳 /cart,恢复按钮 */
        btn.disabled = false; btn.textContent = label;
      } else {
        window.location.href = ROOT + '/cart';
      }
    }).catch(function () { btn.disabled = false; btn.textContent = label; });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-he-mias-add]');
    if (b) { e.preventDefault(); addBoth(b); }
  });

  function init() { document.querySelectorAll('[data-he-mias]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
